import { ReactNode } from 'react';

interface OnlineBadgeProps {
  children: ReactNode;
  show: boolean;
}

export function OnlineBadge({ children, show }: OnlineBadgeProps) {
  if (!show) return <>{children}</>;

  return (
    <div className="relative flex leading-none">
      {children}

      <div className="absolute bottom-0.5 right-0.5 h-1.5 min-h-1.5 w-1.5 min-w-1.5 shrink-0 rounded-full bg-success text-success shadow-bg">
        <div className="absolute inset-0 h-full w-full animate-ripple rounded-full border border-current" />
      </div>
    </div>
  );
}
